<template>
  <div>

    <div id="owner" class="bg-image small"></div>

    <div class="bg-white">
      <div class="container py-3">
        <br class="d-none d-md-block">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="h2">List your trailer</h1>
            <p class="lead grey">Rent out your idle trailers to trusted businesses in your area and start earning.</p>
            <hr>
            <br>
            <div class="row">
      	      <div class="col-md-4">
                <i class="fas fa-3x fa-fw fa-hand-holding-usd blue mb-4"></i>
    						<h5 class="mb-2">Earn extra cash</h5>
    						<p class="grey mb-4">Put your idle trailers to work by renting them out when not in use.</p>
      			  </div>
      	      <div class="col-md-4">
                <i class="far fa-3x fa-fw fa-handshake yellow mb-4"></i>
    						<h5 class="mb-2">Insurance included</h5>
    						<p class="grey mb-4">All rentals include roadside assistance, damage insurance and liability policy.</p>
      	      </div>
      	      <div class="col-md-4">
    						<i class="fas fa-3x fa-fw fa-bullseye red mb-4"></i>
    						<h5 class="mb-2">Stay in control</h5>
    						<p class="grey mb-4">You decide who rents your trailer and set rental price plus trailer availability.</p>
      	      </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    
    <pno-list />

  </div>
</template>

<script>
import PnoList from '@/components/PnoList.vue'

export default {
    mounted() {
      this.$store.commit('meta/title', 'List your trailer')
      this.$store.commit('meta/description', 'Rent out your idle trailers to trusted busineesses in your area and start earning.')
    },
	components: { PnoList }
}
</script>
